// hooks/useCategories.js
// Categories Hook - Synchronized with Mobile App
import { useQuery } from "@tanstack/react-query";
import { apiService } from "../services/api";
import { translateCategories, translateCategory } from "../utils/translateData";

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: async () => {
      const response = await apiService.getCategories();
      const categories = response.data || [];
      return translateCategories(categories);
    },
    staleTime: 1000 * 60 * 5, // 5 minutes - categories don't change often
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    gcTime: 1000 * 60 * 60, // 1 hour
  });
};

export const useCategory = (categoryId) => {
  return useQuery({
    queryKey: ["categories", categoryId],
    queryFn: async () => {
      const response = await apiService.getCategory(categoryId);
      const category = response.data || null;
      return category ? translateCategory(category) : null;
    },
    enabled: !!categoryId,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};

export const useSubcategories = (categoryId) => {
  return useQuery({
    queryKey: ["categories", categoryId, "subcategories"],
    queryFn: async () => {
      const response = await apiService.getSubcategories(categoryId);
      const subcategories = response.data || [];
      return translateCategories(subcategories);
    },
    enabled: !!categoryId,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
};

export default useCategories;

